import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Inter (Latin + Cyrillic), self-hosted: no requests to Google Fonts
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import './index.css'
import App from './App'
import { captureCampaign } from './lib/campaign'

// Keep utm_* from email links for sign-up and checkout attribution (privacy §3.10)
captureCampaign()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
